import { isAfter, isBefore, isExists, startOfDay } from 'date-fns';
import { formatDateStringToObject } from 'syf-js-utilities/formats';
import { getDaysAllowedInFuture, getEndDateForPayment, getEndDateFromDaysAllowedInFuture, getEstDateObject, getEstDateString, getMaximumPaymentDays } from '../../helpers';
import { t } from '../../strings/i18n';
import { required } from '../../xform';
export const getDateError = (selectedDate, endDate, noOfAvailableDays) => {
    const currentDate = startOfDay(getEstDateObject(new Date()));
    if (isBefore(selectedDate, currentDate)) {
        return t('errors.pastDueDate');
    }
    if (isAfter(selectedDate, endDate)) {
        return noOfAvailableDays === 1
            ? t('errors.presentDueDate')
            : t('errors.futureDueDate', { noOfAvailableDays });
    }
    return null;
};
export const isValidDateFormat = (date) => {
    const [year, month, day] = date.split('-').map(Number);
    return isExists(year, month - 1, day);
};
const validateDateRange = (accountSummary, eligibility, isDigitalCollectionsEnabled) => {
    const { billing, product } = accountSummary;
    return (value) => {
        if (value === null || value === undefined || value === '') {
            return;
        }
        /*
         * TODO: ideally would love for this new daysAllowedInFuture attribute to be the source of truth
         * for every product and permutation moving forward but for now it's scoped to just CAP and Settlement
         */
        let endDate = getEndDateForPayment(billing.daysDelinquent, product);
        let noOfAvailableDays = getMaximumPaymentDays(billing.daysDelinquent, product);
        if (isDigitalCollectionsEnabled &&
            (billing.pastDue ||
                billing.customerAssistancePlan ||
                billing.settlementEnrolled)) {
            const daysAllowedInFuture = getDaysAllowedInFuture(eligibility);
            if (!Number.isNaN(daysAllowedInFuture) && daysAllowedInFuture >= 0) {
                endDate = getEndDateFromDaysAllowedInFuture(daysAllowedInFuture);
                noOfAvailableDays = daysAllowedInFuture;
            }
        }
        const paymentDateError = getDateError(formatDateStringToObject(value), endDate, noOfAvailableDays);
        if (paymentDateError) {
            throw new Error(paymentDateError);
        }
    };
};
export const PAYMENT_DATE_INPUT_NAME = 'paymentDate';
const paymentDateConfig = (apiMachineRef) => {
    const api = apiMachineRef.getSnapshot().context;
    const accountSummary = api.accountSummaryQueryResult.data;
    const eligibility = api.paymentEnterpriseEligibilityQueryResult.data;
    const { isDigitalCollectionsEnabled } = api.featureFlags;
    return [
        PAYMENT_DATE_INPUT_NAME,
        getEstDateString(new Date()),
        'ENABLED',
        [
            required(t('errors.paymentDate')),
            validateDateRange(accountSummary, eligibility, isDigitalCollectionsEnabled),
            (value) => {
                if (value === null || value === undefined || value === '') {
                    return;
                }
                if (!isValidDateFormat(value)) {
                    throw new Error(t('errors.invalidDateFormat'));
                }
            }
        ]
    ];
};
export default paymentDateConfig;
